/**
 * 动漫风格配置
 * 统一配置，供 VideoToAnimeSetting.vue 和工作台使用
 */

export interface AnimeStyleConfig {
    /** 翻译键（用于多语言） */
    translationKey: string
    /** 风格值（提交到后端的值） */
    value: string
    /** 风格预览图片 */
    image: string
}

export const animeStylesConfig: AnimeStyleConfig[] = [
    {
        translationKey: 'animeStylePixar',
        value: 'pixar',
        image: 'https://static.weryai.com/growth/image/bab97fee96e1facceccf09d08e63d8bc.webp',
    },
    {
        translationKey: 'animeStyleFlat2d',
        value: 'flat-2d',
        image: 'https://static.weryai.com/growth/image/d85a13c935dee046d374b90951ad3195.webp',
    },
    {
        translationKey: 'animeStyleGhibli',
        value: 'ghibli_style',
        image: 'https://static.weryai.com/growth/image/d79dc9feebd4886b14befd4a150a758c.webp',
    },
    {
        translationKey: 'animeStyleCute',
        value: 'cute',
        image: 'https://static.weryai.com/growth/image/ce2075bd7bcd287cad16d49eda9ca0f9.webp',
    },
    {
        translationKey: 'animeStyleAnime1',
        value: 'anime_style_1',
        image: 'https://static.weryai.com/growth/image/8f80473fdc8805f3d2cec86cb983ed78.webp',
    },
    {
        translationKey: 'animeStyleAnime2',
        value: 'anime_style_2',
        image: 'https://static.weryai.com/growth/image/58f1b66aa1cad29f573d7aa474d6af96.webp',
    },
    {
        translationKey: 'animeStyleAnime3',
        value: 'anime_style_3',
        image: 'https://static.weryai.com/growth/image/04817f32ca4e6e0f579d8567a6b1364d.webp',
    },
    {
        translationKey: 'animeStyleAnime4',
        value: 'anime_style_4',
        image: 'https://static.weryai.com/growth/image/f7e255ea454dedea097e27eb31b18379.webp',
    },
    {
        translationKey: 'animeStyleAnime5',
        value: 'anime_style_5',
        image: 'https://static.weryai.com/growth/image/e9f198d9028d156bfb0184baf8432be4.webp',
    },
    {
        translationKey: 'animeStyleRealistic1',
        value: 'realistic_1',
        image: 'https://static.weryai.com/growth/image/9b8f9977273c573dc283886d94b75ca4.webp',
    },
    {
        translationKey: 'animeStyleRealistic2',
        value: 'realistic_2',
        image: 'https://static.weryai.com/growth/image/5eeb271d7e34a274cf01a92fe68c3495.webp',
    },
    {
        translationKey: 'animeStyleRealistic3',
        value: 'realistic_3',
        image: 'https://static.weryai.com/growth/image/2497c87f520d064ed18d709e8046e1bc.webp',
    },
    {
        translationKey: 'animeStyleMuscular',
        value: 'muscular',
        image: 'https://static.weryai.com/growth/image/bdb491b4241e385391eb249ac00e8288.webp',
    },
    {
        translationKey: 'animeStyleJp1',
        value: 'anime_style_jp1',
        image: 'https://static.weryai.com/growth/image/22d6e9f19b993b11384155e64864e286.webp',
    },
    {
        translationKey: 'animeStyleClay1',
        value: 'clay_1',
        image: 'https://static.weryai.com/growth/image/2756152d84e96a3c459b622780e7e74a.webp',
    },
    {
        translationKey: 'animeStyleClay2',
        value: 'clay_2',
        image: 'https://static.weryai.com/growth/image/7c5c133ab323ce84513b4d8241db822b.webp',
    },
    {
        translationKey: 'animeStyle2d5_1',
        value: '2.5D_1',
        image: 'https://static.weryai.com/growth/image/074ab5d02831225aa97e7989f6e28a5e.webp',
    },
    {
        translationKey: 'animeStyle2d5_2',
        value: '2.5D_2',
        image: 'https://static.weryai.com/growth/image/29bde00f6bcec5aae0d29005111b8b82.webp',
    },
    {
        translationKey: 'animeStylePixel',
        value: 'pixel',
        image: 'https://static.weryai.com/growth/image/0d7e8bbab4068cc3fbe385ccb9c640dd.webp',
    },
    {
        translationKey: 'animeStyleShuimo',
        value: 'shuimo',
        image: 'https://static.weryai.com/growth/image/2abf9725971d6183bee9e81a05b568d5.webp',
    },
    {
        translationKey: 'animeStyleLine',
        value: 'line_style',
        image: 'https://static.weryai.com/growth/image/9475622562affef51a097a7e92bdae40.webp',
    },
    {
        translationKey: 'animeStylePopArt',
        value: 'pop_art',
        image: 'https://static.weryai.com/growth/image/d9c46dfc192d8da7b5cda5e4b75d1bbe.webp',
    },
]
